{
  "feedback-internal-details-page": {
    "buttons": {
      "submit": "XÁC NHẬN"
    },
    "text": {
      "comment": "Bình luận của bạn",
      "cleanliness": "Không gian và sự sạch sẽ",
      "hint": "Hãy chia sẻ cảm nhận của bạn về dịch vụ của chúng tôi",
      "service": "Dịch vụ",
      "staff": "Nhân viên"
    }
  }
}
